<template>
    <div class="hello">
        <!-- <canvas class="fireworks"></canvas> -->
        <div class="content">
            <div class="profile-pic">
                <img :src="require('../assets/shankarg1.jpg')" alt="Shankar Prakash G">
            </div>
            <h1>Shankar Prakash G</h1>
            <p class="tagline">#code #love #eat #sleep</p>
            <!-- <p class="description">
                Co-Founder & Chief Technology Officer of <b><a href="http://zorixoventures.com" title="Zorixo Ventures"
                                                               rel="noopener" target="_blank">Zorixo Ventures</a></b>
            </p> -->
            <div class="social">
                <a v-for="social in socialProfiles" :href="social.url" :title="'Shankar Prakash G on ' +  social.name"
                   rel="noopener" target="_blank">
                    <img :src="require('../assets/svg/' + social.img)" :alt="'Shankar Prakash G on' +  social.name">
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                socialProfiles: [
                    {
                        'name': 'Twitter',
                        'url': 'https://twitter.com/shankargdev',
                        'img': 'twitter.svg'
                    },
                    {
                        'name': 'Github',
                        'url': 'https://github.com/shankargdev',
                        'img': 'github.svg'
                    },
                    {
                        'name': 'LinkedIn',
                        'url': 'https://www.linkedin.com/in/shankarprakashg/',
                        'img': 'linkedin.svg'
                    },
                    {
                        'name': 'Facebook',
                        'url': 'https://www.facebook.com/shankarg.dev',
                        'img': 'facebook.svg'
                    }
                ]
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    @import url('https://fonts.googleapis.com/css?family=Cormorant+Unicase:300&display=swap');

    body {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 100vh;
        margin: 0;
        background: linear-gradient(45deg, #d7ba44, #4CAF50, #44b5d7, #8244d7, #d744b1);
        background-size: 800% 800%;
        animation: bodyBg 400s ease infinite;
    }

    @keyframes bodyBg {
        0% {
            background-position: 91% 0%
        }
        50% {
            background-position: 10% 100%
        }
        100% {
            background-position: 91% 0%
        }
    }

    .content {
        text-align: center;
        color: #fff;
        background: rgba(#000, 0.3);
        padding: 20px 40px 60px;
        margin: 60px 20px;
        border-radius: 5px;
        box-shadow: 0 0 10px 1px rgba(#1f1f1f, .1);

        h1 {
            font-family: 'Cormorant Unicase', serif;
            font-weight: normal;
            font-size: 5em;
            margin: 60px 0 0;
        }

        .tagline {
            margin: 0 0 40px;
            font-size: 1.5em;
            font-style: italic; 
        }

        .description {
            margin-bottom: 40px;
            font-size: 20px;

            a {
                text-decoration: none;
                color: inherit;
                white-space: nowrap;
                position: relative;
                z-index: 1;
            }
        }

        .social {
            display: inline-block;
            background: rgba(#000000, 0.15);
            padding: 10px;
            border-radius: 5px;
            line-height: 0;
            box-shadow: 0 0 10px 1px rgba(#1f1f1f, .1);
            > a {
                display: inline-block;
                position: relative;
                z-index: 1;

                & + a {
                    margin-left: 10px;
                }

                img {
                    width: 50px;
                    display: inline-block;
                }
            }
        }

        .profile-pic {
            width: 150px;
            height: 150px;
            border-radius: 50%;
            overflow: hidden;
            position: absolute;
            left: 50%;
            transform: translate(-50%, -50%);

            img {
                max-width: 100%;
            }
        }
    }

    .fireworks {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    @media screen and (max-width: 480px) {
        .content {
            padding: 20px;
            h1 {
                font-size: 4em;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue